import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import t from '@instructure/quiz-i18n/es/format-message';
import { toErrors } from '../../../util/instUIMessages';
import { simpleFetchBanks } from '../../../../banks/api/banks';
import { GenericAsyncSearch } from '../../shared/GenericAsyncSearch/GenericAsyncSearch';
export var BankSelection = /*#__PURE__*/function (_Component) {
  function BankSelection() {
    var _this;
    _classCallCheck(this, BankSelection);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BankSelection, [].concat(args));
    _defineProperty(_this, "searchBanks", function (search) {
      return _this.props.simpleFetchBanks({
        search: search
      }).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          banks = _ref2[0];
        return banks.map(function (b) {
          return {
            id: b.id,
            text: b.title,
            archived: b.archived
          };
        });
      });
    });
    _defineProperty(_this, "onSelect", function (e, bankOption) {
      return _this.props.onBankSelection(e, {
        id: parseInt(bankOption.id),
        title: bankOption.text,
        archived: bankOption.archived
      });
    });
    return _this;
  }
  _inherits(BankSelection, _Component);
  return _createClass(BankSelection, [{
    key: "getErrors",
    value: function getErrors() {
      var selectedBank = this.props.selectedBank;
      if (selectedBank && selectedBank.archived) {
        return toErrors([t('The item bank "{ bankTitle }" no longer exists. Please select a valid bank.', {
          bankTitle: selectedBank.title
        })]);
      }
    }
  }, {
    key: "selectedOption",
    value: function selectedOption() {
      var selectedBank = this.props.selectedBank;
      return selectedBank ? {
        id: selectedBank.id,
        text: selectedBank.title,
        archived: selectedBank.archived
      } : null;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(GenericAsyncSearch, {
        onSelectionChange: this.onSelect,
        label: this.props.label || t('Select the destination bank'),
        placeholder: t('Search for a bank'),
        selectedOption: this.selectedOption(),
        getOptions: this.searchBanks,
        messages: this.getErrors(),
        selectAutomation: 'sdk-item-bank-modal'
      });
    }
  }]);
}(Component);
_defineProperty(BankSelection, "propTypes", {
  label: PropTypes.string,
  onBankSelection: PropTypes.func,
  selectedBank: ImmutablePropTypes.record,
  simpleFetchBanks: PropTypes.func
});
_defineProperty(BankSelection, "defaultProps", {
  label: null,
  onBankSelection: function onBankSelection() {},
  selectedBank: null,
  simpleFetchBanks: simpleFetchBanks
});
export default BankSelection;